module.exports = __webpack_public_path__ + "img/6@s.00cd3a49.jpg";